import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "/buddy/cc-maintainer-fe/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
export function getUndoActionReports(_ref, _ref2) {
  var dispatch = _ref.dispatch;
  var params = _ref2.params;
  var defaultParams = {
    include: 'admin'
  };
  return dispatch('api', {
    url: 'reports/undo-actions',
    params: _objectSpread(_objectSpread({}, defaultParams), params)
  }, {
    root: true
  });
}
export function getUndoActionReportForAdmin(_ref3, _ref4) {
  var dispatch = _ref3.dispatch;
  var adminId = _ref4.adminId,
    params = _ref4.params;
  var defaultParams = {
    include: 'admin'
  };
  return dispatch('api', {
    url: 'reports/undo-actions/' + adminId,
    params: _objectSpread(_objectSpread({}, defaultParams), params)
  }, {
    root: true
  });
}
export function getUndoActionReportListForAdmin(_ref5, _ref6) {
  var dispatch = _ref5.dispatch;
  var adminId = _ref6.adminId,
    params = _ref6.params;
  var defaultParams = {
    include: 'admin,reviewer,audit.entity'
  };
  return dispatch('api', {
    url: 'reports/undo-actions/' + adminId + '/list',
    params: _objectSpread(_objectSpread({}, defaultParams), params)
  }, {
    root: true
  });
}